import React, { useRef } from 'react';

// tools
import uniqid from '../../../../helpers/uniqid';

const ButtonIconRadio = ({ children, onChange, checked, isSquare = false, disabled = false }) => {
    const uuid = useRef(uniqid());
    const classes = ['appButton__icon']

    if (isSquare) {
        classes.push('appButton__icon--square')
    }

    if (disabled) {
        classes.push('appButton__icon--disabled')
    }

    return(
        <label htmlFor={uuid.current} className={classes.join(' ')}>
            <input type="checkbox" id={uuid.current} onChange={onChange} checked={checked} disabled={disabled}/>
            <div className="appButton__iconInner">
                <div className="appButton__iconInnerLayer1">
                    <div className="appButton__iconInnerLayer2"></div>
                </div>
            </div>
            {children}
        </label>
    )
}

export default ButtonIconRadio;
